import React from 'react';
import PropTypes from 'prop-types';

import { Card, Icon, Statistic } from 'semantic-ui-react';
import { YoutubeIcon, FacebookIcon, TwitterIcon, InstagramIcon, TwitchIcon } from '../../components/dyzio-icons';
import { sciFormatted, commaFormatted } from '../../utils/formatting';

const iconStyle = {
  height: '0.75em',
  margin: '0 5px',
};

const ShortlistSummary = ({
  influencerCount,
  totalTwitter,
  totalInstagram,
  totalYoutube,
  totalFacebook,
  totalTwitch,
  totalTiktok,
}) => (
  <Card fluid color="pink">
    <Card.Content>
      <Card.Header>Shortlist Summary</Card.Header>
    </Card.Content>
    <Card.Content>
      <Statistic.Group widths={7} size="tiny">
        <Statistic>
          <Statistic.Value>
            <Icon name="user" size="small" color="pink" />&nbsp;{ sciFormatted(influencerCount) }
          </Statistic.Value>
          <Statistic.Label>
            {
              `influencer${influencerCount === 1 ? '' : 's'}`
            }
          </Statistic.Label>
        </Statistic>
        <Statistic>
          <Statistic.Value >
            <InstagramIcon size="small" style={iconStyle} />&nbsp;{ sciFormatted(totalInstagram) }
          </Statistic.Value>
          <Statistic.Label>
            Followers
          </Statistic.Label>
        </Statistic>
        <Statistic>
          <Statistic.Value >
            <YoutubeIcon size="small" style={iconStyle} />&nbsp;{ sciFormatted(totalYoutube) }
          </Statistic.Value>
          <Statistic.Label>
            Subscribers
          </Statistic.Label>
        </Statistic>
        <Statistic color="#3B5998">
          <Statistic.Value >
            <FacebookIcon size="small" style={iconStyle} />&nbsp;{ sciFormatted(totalFacebook) }
          </Statistic.Value>
          <Statistic.Label>
            Followers
          </Statistic.Label>
        </Statistic>
        <Statistic>
          <Statistic.Value >
            <TwitterIcon size="small" style={iconStyle} />{ sciFormatted(totalTwitter) }
          </Statistic.Value>
          <Statistic.Label>
            Followers
          </Statistic.Label>
        </Statistic>
        <Statistic>
          <Statistic.Value >
            <img style={iconStyle} src={'/icons/tik-tok.svg'} alt="Tiktok" />{ sciFormatted(totalTiktok) }
          </Statistic.Value>
          <Statistic.Label>
            Followers
          </Statistic.Label>
        </Statistic>
        <Statistic>
          <Statistic.Value >
            <TwitchIcon size="small" style={iconStyle} />{ sciFormatted(totalTwitch) }
          </Statistic.Value>
          <Statistic.Label>
            Followers
          </Statistic.Label>
        </Statistic>
      </Statistic.Group>
    </Card.Content>
    <Card.Content extra>
      showing total counts for all influencers across each platform
    </Card.Content>
  </Card>
);

ShortlistSummary.propTypes = {
  influencerCount: PropTypes.number.isRequired,
  totalTwitter: PropTypes.number.isRequired,
  totalInstagram: PropTypes.number.isRequired,
  totalYoutube: PropTypes.number.isRequired,
  totalFacebook: PropTypes.number.isRequired,
  totalTwitch: PropTypes.number.isRequired,
  totalTiktok: PropTypes.number.isRequired,
};

export default ShortlistSummary;



/** WEBPACK FOOTER **
 ** ./src/components/shortlist-summary/index.js
 **/